import React from 'react';

import type { Account } from '../../../generated-types';
import DownpaymentModal from './DownpaymentModal';
import downpaymentReducer from './form/reducer';
import { downpaymentInitialState } from './form/state';
import { DownpaymentFormContext } from './form/useFormContext';
import useValidate from './form/validate';

import '../TransactionModal.scss';

interface DownpaymentProps {
    open?: boolean;
    setOpen: React.Dispatch<boolean>;
    account?: Account;
    loanAccount?: Account;
    isLoading?: boolean;
}

const Downpayment: React.FC<DownpaymentProps> = ({
    open = false,
    isLoading = false,
    setOpen,
    account,
    loanAccount,
}) => {
    return (
        <DownpaymentFormContext
            validateHook={useValidate}
            reducer={downpaymentReducer}
            initialState={{
                ...downpaymentInitialState,
                fromAccount: account?.accountNumber,
                toAccount: loanAccount?.accountNumber,
            }}
        >
            <DownpaymentModal
                isLoading={isLoading}
                open={open}
                setOpen={setOpen}
                account={account}
                loanAccount={loanAccount}
            />
        </DownpaymentFormContext>
    );
};

export default Downpayment;
